@let blocCompetences = bloc();

<div class="gap-sm flex h-[calc(100vh-170px)]">
  <div class="h-full w-1/3">
    <section class="border-stroke-neutral-light flex h-full flex-col rounded-lg border">
      <div class="border-stroke-neutral-light paragraph-large-semibold p-sm max-h-[55px] border-b">Compétences</div>
      <div class="py-md px-sm gap-xs flex flex-1 flex-col overflow-y-auto">
        @for (competence of blocCompetences.competences; track competence.id) {
          <a
            class="border-stroke-neutral-light py-xs flex flex-col rounded-lg border"
            [ngClass]="{
              'ring-feedback-negative-main ring-2': hasError(competence),
            }"
            [routerLink]="['.']"
            [queryParams]="{ idCompetence: competence.id }"
            href="#"
            routerLinkActive="ring-stroke-primary-main ring-2"
          >
            <div class="px-sm flex justify-between">
              <span class="mr-xs py-xxs">{{ competence.libelle }}</span>
              <div class="text-danger pt-xxs" [class]="{ hidden: !hasError(competence) }">
                <ng-icon name="lucideCircleAlert" hlm />
              </div>
            </div>
          </a>
        }
      </div>
    </section>
  </div>

  <section class="border-stroke-neutral-light flex h-full w-2/3 flex-col rounded-lg border">
    <div class="border-stroke-neutral-light paragraph-large-semibold p-sm max-h-[55px] border-b">Aptitudes</div>
    <div class="p-md overflow-y-auto">
      <app-input-search-filter
        [referentielCourant]="referentiel()"
        (onFilter)="filtrer($event)"
        placeholder="Recherchez des aptitudes"
      >
      </app-input-search-filter>
      @if (aptitudes().length || filtre()) {
        <div class="mt-md gap-xs flex flex-1 flex-col overflow-y-auto">
          @for (aptitude of aptitudes(); track aptitude.id) {
            <div class="gap-xs flex items-center">
              <hlm-checkbox [id]="aptitude.id" [checked]="isChecked(aptitude)" (checkedChange)="changed(aptitude)" />
              <label [for]="aptitude.id" hlmLabel>
                <span class="text-grey-7 items-center uppercase"
                  >{{ aptitude.referentiel }}
                  &nbsp;&bull;&nbsp;
                </span>
                {{ aptitude.nom }}</label
              >
            </div>
          } @empty {
            <p class="text-content-secondary paragraph-medium-medium">Il n'y a pas encore d'aptitudes associées</p>
          }
        </div>
      } @else {
        <p class="text-content-secondary paragraph-medium-medium mt-md">Il n'y a pas encore d'aptitudes associées</p>
      }
    </div>
  </section>
</div>

<div class="gap-sm px-xl py-sm border-stroke-neutral-light fixed right-0 bottom-0 left-0 flex border-t bg-white">
  <button [routerLink]="['..']" hlmBtn variant="secondary" type="button">
    <ng-icon name="lucideArrowLeft" />
    Retourner à gestion des compétences
  </button>
  <button (click)="submit()" hlmBtn type="button">
    Valider le bloc de compétences
    <ng-icon name="lucideCheck" />
  </button>
</div>
